<template>
  <div class="datinfo" >
    <h3>DAT Info</h3>
    <div v-if=" !DATinfo && car.vin && car.baujahr && car.kilometerstand ">
    <button class="button" v-on:click="getDatInfo" v-if="car.vin.trim() != '' && car.baujahr.trim() !='' &&car.kilometerstand.trim() !='' ">DAT anfragen</button>
    </div>

    <div v-if="( !car.vin || (car.vin && car.vin.trim() =='')) ">Bitte VIN angeben!</div>
    <div v-if="( !car.baujahr || ( car.baujahr  && car.baujahr.trim() =='')) ">Bitte Baujahr angeben!</div>
    <div v-if="( !car.kilometerstand || ( car.kilometerstand && car.kilometerstand.trim() =='')) ">Bitte Laufleistung angeben!</div>

    <div v-if="DATinfo">
        <p v-if="DATinfo.data.CreateDate">vorhanden vom {{DATinfo.data.CreateDate.value}}<br> <br></p>
        <dl>
          <dt v-if="DATinfo.data.ManufacturerName">{{DATinfo.data.ManufacturerName.title}}</dt><dd>{{DATinfo.data.ManufacturerName.value}}</dd>
          <dt v-if="DATinfo.data.BaseModelName">{{DATinfo.data.BaseModelName.title}}</dt><dd>{{DATinfo.data.BaseModelName.value}}</dd>
          <dt v-if="DATinfo.data.SubModelName">{{DATinfo.data.SubModelName.title}}</dt><dd>{{DATinfo.data.SubModelName.value}}</dd>
          <dt v-if="DATinfo.data.DatECode">{{DATinfo.data.DatECode.title}}</dt><dd>{{DATinfo.data.DatECode.value}} {{DATinfo.data.Container.value}}</dd>
          <dt v-if="DATinfo.data.Leistung">{{DATinfo.data.Leistung.title}}</dt><dd>{{DATinfo.data.Leistung.value}}</dd>
          <dt v-if="DATinfo.data.Hubraum">{{DATinfo.data.Hubraum.title}}</dt><dd>{{DATinfo.data.Hubraum.value}}</dd>
          <dt v-if="DATinfo.data.Motorart">{{DATinfo.data.Motorart.title}}</dt><dd>{{DATinfo.data.Motorart.value}}</dd>
          <dt v-if="DATinfo.data.Getriebe">{{DATinfo.data.Getriebe.title}}</dt><dd>{{DATinfo.data.Getriebe.value}}</dd>
        </dl>

        <dl>
          <dt v-if="DATinfo.data.Color">{{DATinfo.data.Color.title}}</dt><dd>{{DATinfo.data.Color.value}}</dd>
          <dt v-if="DATinfo.data.SeatsDoors">{{DATinfo.data.SeatsDoors.title}}</dt><dd>{{DATinfo.data.SeatsDoors.value}}</dd>
          <dt v-if="DATinfo.data.KBA">{{DATinfo.data.KBA.title}}</dt><dd>{{DATinfo.data.KBA.value}}</dd>
          <dt v-if="DATinfo.data.Mileage">{{DATinfo.data.Mileage.title}}</dt><dd>{{DATinfo.data.Mileage.value}}</dd>
        </dl>
        <h3>Bewertung</h3>
        <dl>
          <dt v-if="DATinfo.data.OriginalPriceGross">{{DATinfo.data.OriginalPriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.OriginalPriceGross.value ) }}</dd>
          <dt v-if="DATinfo.data.EquipmentOriginalPrice">{{DATinfo.data.EquipmentOriginalPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.EquipmentOriginalPrice.value )}}</dd>
          <dt v-if="DATinfo.data.OriginalPriceGrossGesamt">{{DATinfo.data.OriginalPriceGrossGesamt.title}}</dt><dd class="ddprice" >{{  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.OriginalPriceGrossGesamt.value ) }}</dd>
        </dl>

        <dl>
          <dt v-if="DATinfo.data.RichtwertDAT">{{DATinfo.data.RichtwertDAT.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.RichtwertDAT.value ) }}</dd>
          <dt v-if="DATinfo.data.MileageCorr">{{DATinfo.data.MileageCorr.title}} ({{DATinfo.data.ReferenceMileage.value}}km)</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.MileageCorr.value ) }}</dd>
          <dt v-if="DATinfo.data.InitialRegistrationCorr">{{DATinfo.data.InitialRegistrationCorr.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.InitialRegistrationCorr.value )}}</dd>
        </dl>

        <dl>
          <dt v-if="DATinfo.data.BasiswertDATErmittlung">{{DATinfo.data.BasiswertDATErmittlung.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.BasiswertDATErmittlung.value ) }}</dd>
          <dt v-if="DATinfo.data.SalesPriceGross">{{DATinfo.data.SalesPriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.SalesPriceGross.value ) }}</dd>
          <dt v-if="DATinfo.data.Grundwert">{{DATinfo.data.Grundwert.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.Grundwert.value ) }}</dd>
        </dl>

        <dl class="bold">
          <dt v-if="DATinfo.data.SalesPrice">{{DATinfo.data.SalesPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.SalesPrice.value ) }}</dd>
          <dt v-if="DATinfo.data.EquipmentPrice">{{DATinfo.data.EquipmentPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.EquipmentPrice.value ) }}</dd>
          <dt v-if="DATinfo.data.PurchasePriceGross">{{DATinfo.data.PurchasePriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.PurchasePriceGross.value ) }}</dd>
        </dl>

        <div id="ausstattung">
            <div class="sonderausstattung ausstattung">
              <h3>Sonderausstattung</h3>
              <ul v-for="(item, key, index) in DATinfo.data.SpecialEquipment.value" v-bind:key="key">
                <li v-if=" item.Description ">{{item.Description.value}}</li>
<!--
                <ul v-if=" item.ContainedEquipmentPositions " v-for="(item2, key2, index2) in item.ContainedEquipmentPositions" >
                  <li v-if=" item2.Description ">oo </li>
                </ul>
-->
              </ul>
            </div>

            <div class="serienausstattung ausstattung">
              <h3>Serienausstattung</h3>
              <ul v-for="(item, key, index) in DATinfo.data.SeriesEquipment.value" v-bind:key="key">
                <li v-if=" item.Description ">{{item.Description.value}}</li>
<!--
                <ul v-if=" item.ContainedEquipmentPositions " v-for="(item2, key2, index2) in item.ContainedEquipmentPositions" >
                  <li v-if=" item2.Description ">oo </li>
                </ul>
-->
              </ul>

            </div>

        </div>
    </div>

  </div>
</template>
<script>
import datconfig from './config'
import xml2json from './xml2json'
//import soapRequest from 'easy-soap-request';
import axios from 'axios';
import xml2js from 'xml2js';
import sweetalert from 'sweetalert';


//import fs from 'fs-extra';
//const fs = require('fs');

export default {
  name: 'DatInfo',
  props: ['car'],
  data() {
    return {
      DATinfo: false,
      popUp: null
        }
  },
  sockets: {
    getDATinfo: function( dat ){
      //console.log('socket action DAT');
      this.DATinfo = dat;
      //console.log( this.DATinfo )
    },
  },
  watch: { 
      car: function (){
          //console.log('car updated ' + this.car.vorgangsnummer);
      }
    },
  
/*
  computed: {    {{ parseInt( ('133.000').replace('.','') ) }}
    function(){
      if(this.car.DATinfo) console.log('DATinfo vorhanden');
    }
  },
*/
  created: function(){
    console.log('DAT Info created');
    this.$socket.emit('getDATinfo', { vorgangsnummer: this.car.vorgangsnummer} );
    
    this.popUp = document.createElement("p")
    //this.popUp.innerHTML = 'Stimmen alle Angaben?<br>Laufleistung: '+ this.car.kilometerstand+' km <br>Baujahr: '+this.car.baujahr+'<br>VIN: '+this.car.vin+' ';
    
  },
  methods: {
    
    soapRequest : function (url, headers, xml, timeout = 10000) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url,
          headers,
          data: xml,
          timeout,        
        validateStatus: (status) => {
          return true; // I'm always returning true, you may want to do it depending on the status received
        }        
        }).then((response) => {
          resolve({
            response: {
              headers: response.headers,
              body: response.data,
              statusCode: response.status,
            },
          });
        }).catch((error) => {
          console.log(error);
/*
          console.log(error);
          resolve({
            response: {
              headers: error.response.headers,
              body: error.repsonse.data,
              statusCode: error.response.status,
            },
          });
*/


/*
          if (error.response) {
            console.error(`SOAP FAILLLL1: ${error}`);
            reject(error.response.data);
          } else {
            console.error(`SOAP FAILLLL2: ${error}`);
            reject(error);
          }
*/
        });
      });
    },    

    getDatInfo: function(e){

    this.popUp.innerHTML = 'Stimmen alle Angaben?<br>Laufleistung: '+ this.car.kilometerstand+' km <br>Baujahr: '+this.car.baujahr+'<br>VIN: '+this.car.vin+' ';

    sweetalert({
      title: "DAT Info ziehen?",
      content: this.popUp,
      //html: "",
      icon: "warning",
      buttons: {
      cancel: {
        text: "Nein, abbrechen",
        value: null,
        visible: true,
        className: "",
        closeModal: true,
        },
        confirm: {
        text: "Ja, DAT abrufen!",
        value: true,
        visible: true,
        className: "",
        closeModal: true
        }
      },
      dangerMode: true,
    })
    .then((getdatinfo) => {
      if (getdatinfo) {
          this.requestDATinfo()
          //console.log(currentTarget);
      }
    });

    },
    requestDATinfo: function(){

      const url = datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl';
      const headers = {
        //'user-agent': 'PHP-SOAP/5.5.11\r\n',
        'productVariant': datconfig.productVariant,
        'customerLogin': datconfig.customerLogin,
        'customerNumber': datconfig.customerNumber,
        'customerSignature': datconfig.customerSignature,
        'interfacePartnerNumber': datconfig.interfacePartnerNumber,
        'interfacePartnerSignature': datconfig.interfacePartnerSignature,
        
        'Content-Type': 'text/xml;charset=UTF-8',
        'soapAction': url //datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl' ,
      };

       //var xml = "<SOAP-ENV:Envelope xmlns:SOAP-ENV=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:ns1=\"http://sphinx.dat.de/services/VehicleIdentificationService\"><SOAP-ENV:Body><ns1:getVehicleIdentificationByVin><request><locale country=\"DE\" datCountryIndicator=\"DE\" language=\"de\"/><sessionID></sessionID><coverage>ALL</coverage><restriction>ALL</restriction><vin>WAUZZZ4F35N094804</vin></request></ns1:getVehicleIdentificationByVin></SOAP-ENV:Body></SOAP-ENV:Envelope>";
       var xml = "<SOAP-ENV:Envelope xmlns:SOAP-ENV=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:ns1=\"http://sphinx.dat.de/services/VehicleIdentificationService\">"
                +"<SOAP-ENV:Body><ns1:getVehicleIdentificationByVin>"
                +"<request>"
                +   "<locale country=\"DE\" datCountryIndicator=\"DE\" language=\"de\"/>"
                +   "<restriction>APPRAISAL</restriction>"
                +   "<vin>"+this.car.vin+"</vin>" //SALDEXTESTSTUB001
                +"</request>"
                +"</ns1:getVehicleIdentificationByVin></SOAP-ENV:Body></SOAP-ENV:Envelope>";

      // usage of module
      (async () => {
        const { response } = await this.soapRequest(url, headers, xml, 10000);     // Optional timeout parameter(milliseconds)
        const { body, statusCode } = response;
        
        //console.log('status code '+ statusCode);
        
        var parser = new DOMParser(),
            xmltemp = parser.parseFromString( body ,"application/xml");
        //console.log(xml);
        //console.log( this.datdata.getElementsByTagName("ns1:DatECode")[0].innerHTML  )
        //console.log( xml.getElementsByTagName('ns1:Dossier')[0].innerHTML  )
        //console.log( typeof this.xmlToJson )
        var vehstemp = xmltemp.getElementsByTagName('ns1:Vehicle')
        
        if( vehstemp.length == 1 )
        var vehtemp = this.xmlToJson(  vehstemp[0] );
        
        else if( vehstemp.length > 1 ) {
          swal('Fehler', 'Baujahr stimmt nicht' , 'warning');
          //console.log( vehstemp  );
          return false;
        }
        
        if( statusCode != 200 ) {
          //console.log( xmltemp.getElementsByTagName('faultcode') );
          swal('Fehler in Abfrage 1', xmltemp.getElementsByTagName('faultcode')[0].textContent + " / " + xmltemp.getElementsByTagName('faultstring')[0].textContent , 'warning');
           //console.log(xmltemp)
           return false;
        }




        var vehicleTemp = {
          DatECode : vehtemp.DatECode.value,
          ConstructionTime : vehtemp.ConstructionTime.value,
          Container : vehtemp.Container.value,
          SpecialEquipment : vehtemp.Equipment.SpecialEquipment ? vehtemp.Equipment.SpecialEquipment.EquipmentPosition : [],
          kbaNumbers: vehtemp.kbaNumbers.value,
          colors: []
        }
        
        if( vehtemp.VINResult && vehtemp.VINResult.VINColors && vehtemp.VINResult.VINColors.VINColor )

//          console.log( Array.isArray( vehtemp.VINResult.VINColors ) )          
//          console.log( Array.isArray( vehtemp.VINResult.VINColors.VINColor ) )
          
          if(  Array.isArray( vehtemp.VINResult.VINColors.VINColor ) )
            vehtemp.VINResult.VINColors.VINColor.forEach(function( item, index, arr ){
              console.log( item );
              //vehicleTemp.colors.push( item.Description.value )
            })
          else
            vehicleTemp.colors.push(  vehtemp.VINResult.VINColors.VINColor.Description.value )
        
            //console.log( vehicleTemp.colors );
        
        //console.log(body);
        //console.log(statusCode);
        vehtemp = null
        vehstemp = null
        
        this.getEvaluation( vehicleTemp );
        
      })();      
      


    },
    getEvaluation: function( vehicleTemp ){

        var SpecialEquipment = [];
        vehicleTemp.SpecialEquipment.forEach( function( item ){
          SpecialEquipment.push( '<vxs:EquipmentPosition><vxs:DatEquipmentId>'+item.DatEquipmentId.value+'</vxs:DatEquipmentId></vxs:EquipmentPosition>' )
        })


         var xml2 = "<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" "
                  + "xmlns:val=\"http://www.dat.eu/myClaim/soap/v2/ValuationService\" xmlns:vxs=\"http://www.dat.de/vxs\">"
                  + "<soapenv:Header/>"
                  + "<soapenv:Body>"
                  +   "<val:createValuation>"
                  +   "<!-- mandatory dossier -->"
                  +   "<vxs:Dossier overwrite=\"true\">"
                  +   "<!-- mandatory name of contract -->"
                  +   "<vxs:Name>" + this.car.vorgangsnummer + "</vxs:Name>"
                  +   "<!-- mandatory Language --><vxs:Language>de_DE</vxs:Language>"
                  +   "<!-- mandatory currency --><vxs:Currency>EUR</vxs:Currency>"
                  +   "<vxs:Country>DE</vxs:Country>"

                  +   "<vxs:Vehicle>"
                  +     "<!--mandatory; datECode -->"
                  +     "<vxs:DatECode>"+ vehicleTemp.DatECode +"</vxs:DatECode>"
                  +     "<!--mandatory; container --><vxs:Container>"+ vehicleTemp.Container +"</vxs:Container>"
                  +     "<!--mandatory; construction time --><vxs:ConstructionTime>" + vehicleTemp.ConstructionTime + "</vxs:ConstructionTime>"
                  +     "<!--mandatory; initial registration-->"
                  +     "<vxs:InitialRegistration>"+this.car.baujahr+"</vxs:InitialRegistration>"//"+ this.car.baujahr +"
                  +     "<!--mandatory; milage-->"
                  +     "<vxs:MileageEstimated>"+this.car.kilometerstand+"</vxs:MileageEstimated>" //"+ this.car.kilometerstand +"
                  +     "<vxs:Country>DE</vxs:Country>"
                  +     "<vxs:RegistrationData>"
                  +       "<vxs:LicenseNumber>S DAT 123</vxs:LicenseNumber>"
                  +     "</vxs:RegistrationData>"

                  +     "<vxs:Equipment>"

                  +     "<!--optional; special equipment-->"


                  + ( SpecialEquipment.length > 0 ? "<vxs:SpecialEquipment>" + SpecialEquipment.join("") + "</vxs:SpecialEquipment>" : "" )


                  +       "<!--optional; additional equipment-->"
                  +       "<vxs:AdditionalEquipment>"
                  +         "<vxs:EquipmentPosition>"
                  +           "<vxs:DatEquipmentId>98300</vxs:DatEquipmentId>"
                  +         "</vxs:EquipmentPosition>"
                  +       "</vxs:AdditionalEquipment>"

                  +     "</vxs:Equipment>"
                  +     "</vxs:Vehicle>"
                
                  +      "<vxs:VAT><vxs:VatType>difference</vxs:VatType></vxs:VAT>"

                  +      "<vxs:Valuation>"
                  
                  
                  +       "<!--optional condition-->"
                  +       "<vxs:Condition>"
//                   +         "<vxs:NumberOfOwners>"+this.car.vorbesitzer+"</vxs:NumberOfOwners>"
                  +         "<vxs:AccidentDamage>accident free</vxs:AccidentDamage>"
//                   +         "<vxs:RepairCosts>500</vxs:RepairCosts>"
                  +       "</vxs:Condition>"
                  
                  +     "</vxs:Valuation>"
                  
                  +     "</vxs:Dossier>"
                  +     "<!--Id of existing contract (currently not possible)--><contractId></contractId>"
                  +     "<!-- mandatory type of contract --><contractType>bundle_valuation</contractType>"
                  +     "<!-- mandatory type of network --><networkType>DAT</networkType>"
                  +     "<!--optional data volume--><Coverage>COMPLETE</Coverage>"
                  +     "</val:createValuation>"
                  +     "</soapenv:Body>"
                  +     "</soapenv:Envelope>";


            const url2 = "http://www.dat.eu/myClaim/soap/v2/ValuationService?wsdl"; //datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/ValuationService?wsdl';
            //const url = datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl';
            const headers2 = {
              //'user-agent': 'PHP-SOAP/5.5.11\r\n',
              'productVariant': datconfig.productVariant,
              'customerLogin': datconfig.customerLogin,
              'customerNumber': datconfig.customerNumber,
              'customerSignature': datconfig.customerSignature,
              'interfacePartnerNumber': datconfig.interfacePartnerNumber,
              'interfacePartnerSignature': datconfig.interfacePartnerSignature,              
              'Content-Type': 'text/xml;charset=UTF-8',
              'soapAction': url2 //datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl' ,
            };
            
            
            
            
             //var xml = "<SOAP-ENV:Envelope xmlns:SOAP-ENV=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:ns1=\"http://sphinx.dat.de/services/VehicleIdentificationService\"><SOAP-ENV:Body><ns1:getVehicleIdentificationByVin><request><locale country=\"DE\" datCountryIndicator=\"DE\" language=\"de\"/><sessionID></sessionID><coverage>ALL</coverage><restriction>ALL</restriction><vin>WAUZZZ4F35N094804</vin></request></ns1:getVehicleIdentificationByVin></SOAP-ENV:Body></SOAP-ENV:Envelope>";
            // usage of module
            (async () => {
              const { response } = await this.soapRequest(url2, headers2, xml2, 10000); // Optional timeout parameter(milliseconds)
              const { body, statusCode } = response;
              
              //faultstring
/*
                    xml2js.parseString(body, function (err, result) {
                      console.dir(result);
                    });
                    
                    console.log( body );
                    console.log(statusCode);
*/
                    this.proceedDATdata(body, vehicleTemp, statusCode);
                    
                    
            })();      

    },
    proceedDATdata: function( remoteXML, vehicleTemp, statusCode ){

      //console.log( remoteXML );
      var parser = new DOMParser(),
          xml = parser.parseFromString( remoteXML ,"application/xml");
      //console.log(xml);
      //console.log( this.datdata.getElementsByTagName("ns1:DatECode")[0].innerHTML  )
      //console.log( xml.getElementsByTagName('ns1:Dossier')[0].innerHTML  )
      //console.log( typeof this.xmlToJson )
      
     if( statusCode != 200 ) {
           //console.log( xml.getElementsByTagName('faultstring') ); 
           swal('Fehler in Abfrage 2', xml.getElementsByTagName('faultstring')[0].textContent , 'warning');
           console.log(xmltemp)
               return false;
           }

      
      
      var dossier = this.xmlToJson( xml.getElementsByTagName('ns1:Dossier')[0]  );
      
      //console.log( dossier );

      this.DATinfo = { 
                      id: null,
                      vorgangsnummer: this.$store.state.editingCarID,
                      data: {
                        CreateDate: {
                          title: "Datum",
                          value: dossier.CreateDate.value
                        },
                        ManufacturerName: {
                          title: "Hersteller",
                          value: dossier.Vehicle.ManufacturerName.value
                        },
                        BaseModelName: {
                          title: "Model",
                          value: dossier.Vehicle.BaseModelName.value
                        },
                        ConstructionTime: {
                          title: "Bauzeit",
                          value: dossier.Vehicle.ConstructionTime.value
                        },
                        Container: {
                          title: "Container",
                          value: dossier.Vehicle.Container.value
                        },
                        ContainerName: {
                          title: "ContainerName",
                          value: dossier.Vehicle.ContainerName.value
                        },
                        
                        SpecialEquipment: {
                          title: "AdditionalEquipment",
                          value: dossier.Vehicle.Equipment.SpecialEquipment ? dossier.Vehicle.Equipment.SpecialEquipment.EquipmentPosition : []
                        },
                        
                        SeriesEquipment: {
                          title: "Serienaussattung",
                          value: dossier.Vehicle.Equipment.SeriesEquipment.EquipmentPosition
                        },
                        DatECode: {
                          title: "DatECode",
                          value: dossier.Vehicle.DatECode.value
                        },
                        SubModelName: {
                          title: "Typ",
                          value: dossier.Vehicle.SubModelName.value
                          },
                        SalesDescription: {
                          title: "SalesDescription",
                          value: dossier.Vehicle.SalesDescription.value
                          },   
                        Leistung: {
                          title: "Leistung",
                          value: dossier.Vehicle.TechInfo.PowerKw.value + " kW / " + dossier.Vehicle.TechInfo.PowerHp.value + " PS"
                        },
                        Hubraum: {
                          title: "Hubraum",
                          value: dossier.Vehicle.TechInfo.Capacity.value + " ccm"
                        },
                        Motorart: {
                          title: "Motorart",
                          value: dossier.Vehicle.TechInfo.FuelMethod.value
                        },
                        Getriebe: {
                          title: "Getriebe",
                          value: dossier.Vehicle.TechInfo.GearboxType.value
                        },
                        Color: {
                          title: "Farbe",
                          value: vehicleTemp.colors[0]
                        },
                        SeatsDoors: {
                          title: "Sitzülätze / Türen",
                          value: dossier.Vehicle.TechInfo.VehicleSeats.value + " / " + dossier.Vehicle.TechInfo.VehicleDoors.value
                        },
                        KBA: {
                          title: "KBA-Schlüssel",
                          value: vehicleTemp.kbaNumbers
                        },
                        Mileage: {
                          title: "Laufleistung",
                          value: dossier.Vehicle.MileageEstimated.value + " km"
                        },
                        EquipmentOriginalPrice: {
                          title: "Listenpreis für Sonderausstattung",
                          value: dossier.Valuation.EquipmentOriginalPrice.value
                        },

                        OriginalPriceGross: {
                          title: "Listenpreis nach DAT",
                          value: dossier.Valuation.OriginalPriceGross.value
                        },
                        OriginalPriceGrossGesamt: {
                          title: "Listenpreis gesamt",
                          value: parseFloat(dossier.Valuation.EquipmentOriginalPrice.value) + parseFloat(dossier.Valuation.OriginalPriceGross.value)
                        },
                        
                        
                        RichtwertDAT: {
                          title: "Richtwert nach DAT",
                          value: dossier.Valuation.BasePrice.value
                        },   
                        
                        MileageCorr: {
                          title: "Laufleistungskorrektur",
                          value: dossier.Valuation.MileageCorr.value
                        },
                        ReferenceMileage: {
                          title: "Bezugslaufleistung",
                          value: dossier.Valuation.ReferenceMileage.value
                        },
                        InitialRegistrationCorr: {
                          title: "Erstzulassungskorrektur",
                          value: dossier.Valuation.InitialRegistrationCorr.value
                        },
                        BasiswertDATErmittlung: {
                          title: "Basiswert durch DAT-Ermittlung",
                          value: dossier.Valuation.BasePrice2.value
                        },
                        EquipmentPrice: {
                          title: "Gesamtwert der Ausstattungen",
                          value: dossier.Valuation.EquipmentPrice.value
                        },
                        Grundwert: {
                          title: "Grundwert durch DAT Ermittlung",
                          value: dossier.Valuation.BasePrice3.value
                        },
                        SalesPrice: {
                          title: "Händlerverkaufswert",
                          value: dossier.Valuation.SalesPrice.value
                        },
                        SalesPriceGross: {
                          title: "Händlerverkaufswert inkl. MwSt.",
                          value: dossier.Valuation.SalesPriceGross.value
                        },        
                        PurchasePriceGross: {
                          title: "Händlereinkaufswert",
                          value: dossier.Valuation.PurchasePriceGross.value
                        }                
                      }
                      //datjson :  this.xmlToJson( xml.getElementsByTagName('ns1:Vehicle')[0]  )
                    }
      
      
      //console.log( JSON.stringify( this.DATinfo ));
      this.saveDATinfo();
     //console.log(   xmljson )   
     //console.log( JSON.stringify(xmljson) )

    },
    saveDATinfo: function() {
      //console.log( 'save DAT' );
      this.$socket.emit('saveDATinfo', this.DATinfo );
    },

    xmlToJson: function(xml) {

          //console.log(xml);
          //return "";

          // Create the return object
          var obj = {};
          
          if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 100) {
              obj["@attributes"] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                  var attribute = xml.attributes.item(j);
                  obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
              }
            } else if (xml.nodeType == 3) { // text
              obj = xml.nodeValue;
              //console.log(xml.nodeName);
              //console.log(xml.nodeValue);
            }
          
            // do children
            if (xml.hasChildNodes()) {
              for(var i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nN = item.nodeName.split(':');
                var nodeName = (nN.length > 1 ? nN[1] : item.nodeName );
                //console.log(nodeName);
                if( nodeName == '#text' ) nodeName = 'value';
                if (typeof(obj[nodeName]) == "undefined") {
                  obj[nodeName] = this.xmlToJson(item);
                } else {
                  if (typeof(obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];
                    //console.log( 'ALT' + old );
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                obj[nodeName].push(this.xmlToJson(item));
                }
              }
            }
            return obj;
      }
    
  }
} 
</script>
<style scoped>
  .datinfo { height: auto; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd;  padding: 0.9333333em 0; }
  .datinfo dl { display: flex; flex-wrap: wrap; align-content: flex-start; align-items: flex-start; padding-bottom: 0.933333em; max-width: 35em; }
  .datinfo dt { flex: 1 1 50%; border-bottom: 1px solid #efefef; }
  .datinfo dd { flex: 1 1 50%; border-bottom: 1px solid #efefef; text-align: right; }
  .datinfo dd.ddprice { text-align: right; }
  .datinfo dl.bold dt,
  .datinfo dl.bold dd { font-weight: bold; }
  .ausstattung { padding: 0 0 1.83333em 0; }
</style>